export const geofence = {
  allFleets: "所有车间",
  bindVehiclesToThisGeofence: "应用电子围栏并设置警示规则",
  boundariesShouldNotIntersectWithEachOther: "边界不可交叉。",
  boundVehicles: "关联设备",
  cancel: "取消",
  confirmDeletion: "确认删除",
  confirmDeletionContent:
    "电子围栏“{name}”将被删除。确定要继续吗？ | 电子围栏“{name}”将被删除，该电子围栏有关联设备。确定要继续吗？",
  deletedSuccessfully: "删除成功",
  description: "说明",
  descriptionCannotBeEmpty: "请输入说明",
  duplicateGeofenceName: "此电子围栏名称已存在。",
  editGeofence: "编辑电子围栏",
  enterZone: "驶入",
  exitZone: "驶出",
  failedToAddGeofence: "保存失败。",
  failedToDeleteGeofence: "删除失败。",
  failedToEditGeofence: "@:geofence.failedToAddGeofence",
  geofenceCannotBeEmpty: "请在地图上绘制电子围栏。",
  doesNotExists: "电子围栏{name}不存在。",
  geofenceName: "电子围栏名称",
  geofencNameCannotBeEmpty: "请输入电子围栏名称",
  locate: "定位",
  newGeofence: "新建电子围栏",
  next: "下一步",
  OK: "好",
  pleaseInputVehicleID: "设备编号",
  save: "保存",
  savedSuccessfully: "保存成功",
  search: "查找",
  vehicle: "设备",
  circle: "圆形",
  polygon: "多边形",
  clear: "清除",
  close: "关闭",
};
